import { ProgressBar } from '@sgme/ui';
import { Layout } from 'components/missed-deal-feedback/components/layout';
import { MissedDealFeedbackReadonlyForm } from 'components/missed-deal-feedback/components/readonly-form';
import { SubmissionStatus } from 'components/missed-deal-feedback/components/submission-status';
import { useAppSelector } from 'hooks/useAppSelector';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import type { IntlKey } from 'locales';
import { FormattedMessage } from 'react-intl';
import { FormIdProps } from 'shared/props';
import { missedDealFeedbackSubmissionRequestDiscarded } from 'state/missed-deal-feeedback/actions';
import { getTechnicalError } from 'state/missed-deal-feeedback/selectors';

export function MissedDealFeedbackSubmissionFailedForm({ formId }: FormIdProps) {
  return (
    <Layout.Wrapper>
      <Layout.Body>
        <MissedDealFeedbackReadonlyForm formId={formId} />
      </Layout.Body>
      <Status formId={formId} />
    </Layout.Wrapper>
  );
}

function Status({ formId: tabId }: FormIdProps) {
  const technicalError = useAppSelector(s => getTechnicalError(s, tabId));
  const dispatch = useThunkDispatch();
  return (
    <>
      <SubmissionStatus
        color="error"
        iconName="info_outline"
        textIntlKey={technicalError ? (technicalError.message as IntlKey) : 'missedDealFeedback.generic.error.message'}
      >
        <button
          className="btn btn-primary"
          data-e2e="missedDealFeedback-ok-button"
          onClick={() => dispatch(missedDealFeedbackSubmissionRequestDiscarded(tabId))}
        >
          <FormattedMessage id="ok" />
        </button>
      </SubmissionStatus>
      <ProgressBar size="md" color="danger" value={0} />
    </>
  );
}
